<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidadeId"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competencia"
                    label="Mês"
                    show-default-option
                    text-field="mes"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competencia"
                    label="Ano"
                    show-default-option
                    text-field="ano"
                    v-model="model.competenciaId"
                    value-field="id"
                    disabled
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

import mesesAno from '@/enums/geral/mesesAno'

export default {
    computed: {
        validations() {
            return {
                unidadeId: { required: true },
                competenciaId: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            procedimentoConsolidado: this.getConectaSusRepository('bpa.procedimentoConsolidado'),
        }
    },
    data: () => ({ 
        form: {},
        model: {},
        enums: {
            mesesAno
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = { acao: 'exclusao' }

            this.repositories.procedimentoConsolidado.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.form.competencias = this.form.competencias.map(c => {
                        return {
                            id: c.id,
                            mes: this.enums.mesesAno[parseInt(c.valor.slice(4))],
                            ano: c.valor.slice(0,4)
                        }
                    })
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        destroy() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        this.repositories.procedimentoConsolidado.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>